import { render, staticRenderFns } from "./SendToVerifyReview.vue?vue&type=template&id=7857e263&scoped=true"
import script from "./SendToVerifyReview.vue?vue&type=script&lang=js"
export * from "./SendToVerifyReview.vue?vue&type=script&lang=js"
import style0 from "./SendToVerifyReview.vue?vue&type=style&index=0&id=7857e263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7857e263",
  null
  
)

export default component.exports